<template>
  <div class="propersolutionMain">
        <div class="solttionCon">
          <div class="solttionConItem">
            <div class="solttionConHead">
              <ul>
                <li></li>
                <li>行业痛点</li>
              </ul>
            </div>
            <div class="solutionList">
                <ul v-if="difficultList.length>0" >
                  <li v-for="(item,index) in difficultList" :key="index">
                      <div><img :src="item.img"></div>
                      <dl>
                        <dt>{{item.title}}</dt>
                        <dd>{{item.content}}</dd>
                      </dl>
                  </li>
                </ul>
            </div>
          </div>
          <div class="solttionConItem">
            <div class="solttionConpor">
              <div class="solttionConHead">
                <ul>
                  <li></li>
                  <li>解决方案</li>
                </ul>
              </div>
              <div class="programBox">
                  <div class="programBoxHead">
                     <div class="programItem">
                       <div class="programItemName">房屋租赁</div>
                        <ul v-if="flowListx.length>0" class="listBottom">
                          <li v-for="(item,index) in flowListx" :key="index">
                            <dl>
                              <dt><span v-html="item.name"></span></dt>
                              <dd>{{item.content}}</dd>
                            </dl>
                          </li>
                        </ul> 
                        <p>
                          对于房屋租赁行业，可通过智签电子签约平台签订的合同或文书有《房屋委托合同》、《租房合同》、《委托找房合同》、《房屋交割清单》、《信用付款协议》等。
                        </p>
                     </div>
                     <div class="programItem programItemc">
                      <div class="programItemName ">汽车租赁</div>
                        <ul v-if="flowLists.length>0">
                          <li v-for="(item,index) in flowLists" :key="index">
                            <dl>
                              <dt><span v-html="item.name"></span></dt>
                              <dd>{{item.content}}</dd>
                            </dl>
                          </li>
                        </ul> 
                      <p>对于汽车租赁行业，可通过智签电子签约平台签订的合同或文书有《车辆委托合同》、《租车合同》、《车辆交割清单》、《违章代扣协议》、《租车保险合同》、《信用付款协议》等。</p>
                    </div>
                  </div>
              </div>

            </div>
          </div>
           <div class="solttionConItem">
              <div class="solttionConHead">
                <ul>
                  <li></li>
                  <li>特色保障</li>
                </ul>
              </div>
              <div class="guaranteeList">
                <ul>
                  <li v-for="(item,index) in guaranteeList" :key="index">
                    <div>
                        <img :src="item.img" class="BigImg">
                        <span class="icon" v-bind:style="{backgroundImage:'url(' + item.icon + ')'}"></span>
                    </div>
                    <dl>
                      <dt><span v-html="item.title"></span></dt>
                      <dd>{{item.content}}</dd>
                    </dl>
                  </li>
                </ul>
              </div>
           </div>
        </div>
    </div>
</template>
<script>
export default {
  data(){
    return{
      difficultList:[
        {
          img:require('../../../assets/images/solution/cbxld_icon.png'),
          title:'签署难成本高',
          content:'在线旅游行业近些年发展迅速，多为跨地区客户，纸质合同签署流程繁琐，耗时长，效率低，签署成本高。'
        },
        {
          img:require("../../../assets/images/solution/safe_icon.png"),
          title:"安全性差",
          content:"因其自身的特点，纸质文件存在易丢失、易损毁的特点，一旦文件被损毁或者丢失，将会造成严重的后果。"
        },
        {
          img:require("../../../assets/images/solution/jyhgyq_icon.png"),
          title:"证据链不全",
          content:"纸质合同的签署，最终的证据只是一份合同，缺少证明当事人行为事实的完整证据链。"
        },
      ],
      guaranteeList:[
        {
          img:require("../../../assets/images/solution/legal_img.png"),
          icon:require('../../../assets/images/solution/legal_nor_icon.png.png'),
          title:"法律效力",
          content:"对接公安部、工商局、银联数据库进行实名认证，保障合同主体可信，采用数字证书，可信时间源等方式，保障合同司法效力。"
        },
        {
          img:require("../../../assets/images/solution/signcontrol_img.png"),
          icon:require('../../../assets/images/solution/signcontrol_pre_icon.png.png'),
          title:"签控一体",
          content:"签约、履约等全证据链全部通过司法联盟链进行存证，通过智能合约进行履约管控，控制违约风险，保障签约方的合法权益。"
        },
        {
          img:require("../../../assets/images/solution/judicial_img.png"),
          icon:require('../../../assets/images/solution/judicial_nor_icon.png'),
          title:"司法保障",
          content:"司法联盟链同步至多家公证处、司法鉴定机构，仲裁机构以及互联网法院，多方参与共识，保证电子数据作为证据的司法证明能力。"
        },
        {
          img:require("../../../assets/images/solution/jbzx_img.png"),
          icon:require('../../../assets/images/solution/jdcb_nor_icon.png'),
          title:"降本增效",
          content:"减少线下签署环节，减少人力、邮寄、纸质合同及管理成本。达到大幅度提高人力资源管理工作的效率并降低成本的目的。"
        },
      ],
      flowListx:[
       {
         name:"注册<br/>实名",
         content:'注册账号，同意服务协议，填写相关资料进行实名认证'
       },
       {
         name:"选定<br/>房源",
         content:'客户确定租房意愿，选定房源'
       },
       {
         name:"客户<br/>签署",
         content:'客户在线发起合同签署签订《租房合同》'
       },
       {
         name:"自动<br/>签署",
         content:'房屋租赁调用签署接口，自动完成合同签署'
       },
       {
         name:"数据<br/>存证",
         content:'全证据链电子数据存证上链，同步至司法联盟链'
       },
       {
         name:"创建<br/>履约",
         content:'通过合同内容，生成履约条款，写入智能合约'
       },
        {
         name:"自动<br/>执行",
         content:'根据职能合约写入的出发条件，满足时自动执行相应的计算机协议'
       },
       {
         name:'纠纷<br/>处理',
         content:'对于违约或者执行失败的合约，提供司法通道服务，进行在线纠纷解决'
       }
      ],
      flowLists:[
        {
         name:"注册<br/>实名",
         content:'注册账号，同意服务协议，填写相关资料进行实名认证'
       },
       {
         name:"选定<br/>车型",
         content:'客户确定租车意愿，选定车型'
       },
       {
         name:"租车人<br/>签署",
         content:'客户在线发起合同签署签订《租车合同》'
       },
       {
         name:"平台<br/>签署",
         content:'汽车租赁公司调用签署接口，自动完成合同签署'
       },
       {
         name:"数据<br/>存证",
         content:'全证据链电子数据存证上链，同步至司法联盟链'
       },
       {
         name:"创建<br/>履约",
         content:'通过合同内容，生成履约条款，写入智能合约'
       },
        {
         name:"自动<br/>执行",
         content:'根据智能合约写入的触发条件，满足时自动执行相应的计算机协议'
       },
       {
         name:'纠纷<br/>处理',
         content:'对于违约或者执行失败的合约，提供司法通道服务，进行在线纠纷解决'
       }
      ],
    }
  }
}
</script>
<style lang="scss" >
.propersolutionMain{
    width:100%;
    .solttionCon{
      .solttionConItem{
        width:1180px;
       padding-bottom:40px;
       margin:0 auto;
        .solttionConHead{
          width: 100%;
          overflow: hidden;
          padding-top: 40px;
          padding-bottom: 30px;
          li{
            float: left;
            line-height: 18px;
          }
          li:nth-child(1){
            height: 18px;
            width:4px;
            background: #B41C2E;
            margin-right: 10px;
          }
          li:nth-child(2){
            font-family: 'PingFangSC-Light';
            font-size: 18px;
            color: #464646;
          }
        }
        .solutionList{
          width:100%;
          height: 190px;
          li{
            width: calc((100% - 40px) / 3);
            height: 190px;
            float: left;
            display: flex;
            justify-content: space-between;
            flex-direction: column;
            margin-right: 20px;
            padding:20px;
            box-sizing: border-box;
            border: 1px solid rgb(235,235,235);
            div{
              text-align: right;
              img{
                width:48px;
                height: auto;
              }
            }
            dl{
              dt{
                font-size: 18px;
                color: #464646;
                font-weight: 550;
                margin-bottom: 10px;
              }
              dd{
                font-size: 13px;
                color: #787878;
                line-height: 19px;
                text-align: justify;
              }
            }
          }
          li:last-child{
            margin-right: 0;
          }
          li:hover{
            box-shadow: 0 2px 12px 0 rgba(0,0,0,0.20);
             border-color: #fff;
          }
        }
        .programBox{
          width:100%;
          overflow: hidden;
          .programBoxHead{
            width: 100%;
            .programItem{
              width:100%;
              overflow: hidden;
              background: #FAFAFA;
              border: 1px dashed rgb(180,180,180);
               box-sizing: border-box;
               margin-bottom:30px;
              .programItemName{
                height: 40px;
                line-height: 40px;
                font-size: 18px;
                text-align: center;
                color: #646464;
                background: #F0F0F0;
                border-bottom: 1px dashed rgb(180,180,180);
                box-sizing: border-box;
              }
              p{
                height: 40px;
                line-height: 40px;
                font-size: 14px;
                text-align: center;
                color: #646464;
                background: #FAFAFA;
                border-top: 1px dashed rgb(180,180,180);
              }
              ul{
                width:100%;
                display: block;
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                padding:40px 20px 20px 20px;
                box-sizing: border-box;
                li{ 
                  text-align:center;
                  position: relative;
                  dl{
                    width:100px;
                    dt{
                      width: 60px;
                      height: 60px;
                      border: 2px dashed #505050;
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      box-sizing: border-box;
                      border-radius: 12px;
                        margin:0 auto;
                        margin-bottom: 12px;
                      span{
                        font-size: 16px;
                        color: #323232;
                        opacity: 0.8;
                        font-weight: bold;
                        font-family: 'PingFangSC-Semibold';
                      }
                    }
                    dd{
                      font-size: 14px!important;
                    color: #969696!important;
                    line-height: 22px;
                    text-align: justify;
                    margin:0 !important;
                    }
                  }
                }
                li:after{
                 content: '';
                    display: block;
                    position: absolute;
                    right: -54px;
                    top: 27px;
                    width: 61px;
                    height: 9px;
                    background:url("../../../assets/images/solution/shrz_line_img.png")no-repeat;
                    background-size:100% 100%;
                }
                li:last-child:after{
                  background: none;
                }
                li:nth-child(7):after{
                   background: none;
                 }
                 li:nth-child(6):before{
                       content: '';
                        display: block;
                        position: absolute;
                        left: 51px;
                        top: -18px;
                        width: 309px;
                       height: 20px;
                      background:url("../../../assets/images/solution/wan.png")no-repeat;
                 }
              }
            } 
            .programItemc{
              margin-bottom: 0;
              ul{
                li{
                  dl{
                    dt{
                      width:60px;
                      height: 60px;
                      background: #B41C2E;
                      border-radius: 12px;
                      margin:0 auto;
                      border:0;
                      margin-bottom: 12px;
                      span{
                        opacity: 0.8;
                      font-family: 'PingFangSC-Semibold';
                      font-size: 16px;
                      color: #FFFFFF;
                      letter-spacing: 2px;
                      }
                    }
                    dd{
                      font-family: 'PingFangSC-Regular';
                      font-size: 14px!important;
                      color: #969696!important;
                      line-height: 22px;
                    }
                  }
                }
              }
            }
          }
          .programBoxCon{
            h1{
              width:100%;
              height: 60px;
              line-height: 60px;
              text-align: center;
              font-size: 18px;
              font-weight: normal;
              color: #787878;
              background: #EBEBEB;
              margin-bottom: 16px;
            }
            p{
              font-size: 14px;
              color:#787878;
              line-height: 26px;
              text-indent: 2em;
              text-align: justify;
              margin-bottom: 20px;
            }
          }
        }
        .solttionConpor{
          max-width: 1180px;
          margin:0 auto;
        }
        .guaranteeList{
          width:100%;
          height: 328px;
          li{
            width: calc((100% - 78px) / 4);
            height: 328px;
            float: left;
            margin-right: 26px;
            box-sizing: border-box;
            padding:2px;
            border: 1px solid rgb(235,235,235);
            div{
              width:100%;
              height: 160px;
              position: relative;
              .BigImg{
                width:100%;
                height: 100%;
              }
              .icon{  
                position: absolute;
                top:50%;
                left:50%;
                margin-top:-19px;
                margin-left: -20px;
                width:40px;
                height: 38px;
                background-size:100% 100%;
              }
            }
            dl{
              dt{
                font-size: 18px;
                color: #464646;
                font-weight: 550;
                margin-top:11px;
                margin-bottom: 15px;
                text-align: center;
                span{
                  display: inline-block;
                  padding-bottom: 6px;
                  border-bottom: 2px solid #B4B4B4;
                }
              }
              dd{
                box-sizing: border-box;
                padding:0 16px;
                font-size: 14px;
                color: #787878;
                line-height: 21px;
                text-align: justify;
              }
            }
          }
          li:last-child{
            margin-right: 0;
          }
          li:hover{
            box-shadow: 0 2px 12px 0 rgba(0,0,0,0.20);
            border-color: #fff;
            dl dt span{
              border-color:#686868;
            }
          }
          li:nth-child(1):hover{
            div .icon{
              background-image:url('../../../assets/images/solution/legal_hov_icon.png')!important;
            }
          }
          li:nth-child(2):hover{
            div .icon{
              background-image:url('../../../assets/images/solution/signcontrol_hov_icon.png')!important;
            }
          }
          li:nth-child(3):hover{
            div .icon{
              background-image:url('../../../assets/images/solution/judicial_hov_icon.png.png')!important;
            }
          }
          li:nth-child(4):hover{
            div .icon{
              background-image:url('../../../assets/images/solution/jdcb_hov.png')!important;
            }
          }
        }
      }
      .solttionConItem:nth-child(2){
        width: 100%;
        background: #F3F2F2;
      }
    }
  }
</style>
